import {Component, OnInit, ViewChild} from '@angular/core';
import {UiService} from '../../../../services/ui.service';
import {MenuMasterItemConfigurationModel} from '../../../../models/ui/menu/menu-master-item-configuration.model';
import {TdoTableSelectionEvent} from '../../../../tdo-controls/common/tdo-table-v2/models/tdo-table-selection.event';
import {TdoTableV2Component} from '../../../../tdo-controls/common/tdo-table-v2/tdo-table-v2.component';

@Component({
  selector: 'app-menu-master-items-configuration',
  templateUrl: './menu-master-items-configuration.component.html',
  styleUrls: ['./menu-master-items-configuration.component.scss']
})
export class MenuMasterItemsConfigurationComponent implements OnInit {
  @ViewChild('table') table: TdoTableV2Component;

  isLoading = true;
  items: MenuMasterItemConfigurationModel[] = [];
  selectedItem: MenuMasterItemConfigurationModel;

  constructor(private uiService: UiService) { }

  ngOnInit(): void {
    this.uiService.getMenuMasterItems().subscribe((miRes) => {
      this.items = miRes;
      this.isLoading = false;
    });
  }

  onRowSelected(event: TdoTableSelectionEvent) {
    this.selectedItem = event.model;
  }

  onNewMenuItem(event: any) {
    const item = new MenuMasterItemConfigurationModel();
    this.items.unshift(item);
    this.selectedItem = item;
    this.table.updateData(this.items);
  }

  save() {
    this.uiService.saveMasterMenuItem(this.selectedItem).subscribe((res) => {
      this.selectedItem = res;
    });
  }

  onMenuItemNameFinished(event: any) {
    this.selectedItem.MenuItemName = event;
    this.save();
  }

  onMenuItemCaptionFinished(event: any) {
    this.selectedItem.MenuItemCaption = event;
    this.save();
  }

  onMenuItemDescriptionFinished(event: any) {
    this.selectedItem.Description = event;
    this.save();
  }

  onMenuItemRouteFinished(event: any) {
    this.selectedItem.CommandRout = event;
    this.save();
  }

  onDelete(model: MenuMasterItemConfigurationModel) {
    this.uiService.deleteMasterMenuItem(model).subscribe(() => {
      const idx = this.items.findIndex(p => p === model);
      if (idx > -1) {
        this.items.splice(idx, 1);
        this.table.updateData(this.items);
      }
    });
  }
}
